module.exports = __webpack_public_path__ + "static/img/10.5ce9b70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour5/10.jpg
// module id = IKdt
// module chunks = 0